// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1-ESH","header":"MergedInvoice_header__C_6pr"};